module.exports = __webpack_public_path__ + "img/ic_search.ba5d8189.svg";